import OotrTrackerRouteConfig from "../../ootr/OotrTrackerRouteConfig";
import { CustomRoute } from "../main/routing/CustomRoute";


const appRoutesConfig: Array<CustomRoute> = [
    ...OotrTrackerRouteConfig
    //...TprTournamentRouteConfig,
]

export default appRoutesConfig;